<template>
    <div class="sakura-child-panel">
      <template v-if="list.length > 2">
        <div class="net-work-row flex-layout" style="align-items: center">
          <div
            class="net-work-port"
             v-for="(item, index) in evenList"
            :key="`even-${index}`"
          >
            <div class="port-item port-item-one">
              <component
                :is="calcPanel(item.type)"
                @port-click="() => emit('port-click', item)"
                @change="(num) => emit('change', num, item)"
                :type="item.type"
                :isEnabledTu="isEnabledTu && item.isEnabledTu"
                v-model:tu="item.tu"
                :port="item.portNum"
                :popover="popover"
                :isEnabled="isEnabled && item.isEnabled"
                :status="item.status"
                :borderStatus="item.borderStatus"
                v-model="item.selected"
                :hex="item.hex"
                :mode="item.mode"
                :detach="item.detach"
                :lag="item.lag"
                :priority="item.priority"
                :vendor="item.detect"
                :config="item.config"
                :isFanout="false"
                :value="item.selected"
              >
                {{ item.value }}
              </component>
            </div>
          </div>
        </div>

        <div class="net-work-row flex-layout" style="align-items: center">
          <div
            class="net-work-port"
            v-for="(item, index) in oddList"
            :key="`odd-${index}`"
          >
            <div class="port-item port-item-one">
              <component
                :is="calcPanel(item.type)"
                @port-click="() => emit('port-click', item)"
                @change="(num) => emit('change', num, item)"
                :type="item.type"
                :isEnabledTu="isEnabledTu && item.isEnabledTu"
                v-model:tu="item.tu"
                :port="item.portNum"
                :popover="popover"
                :isEnabled="isEnabled && item.isEnabled"
                :status="item.status"
                :borderStatus="item.borderStatus"
                v-model="item.selected"
                :hex="item.hex"
                :mode="item.mode"
                :detach="item.detach"
                :lag="item.lag"
                :priority="item.priority"
                :vendor="item.detect"
                :config="item.config"
                :isFanout="false"
                :value="item.selected"
              >
                {{ item.value }}
              </component>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="net-work-row flex-layout" style="align-items: center">
          <div
            class="net-work-port"
            v-for="(item, index) in list"
            :key="`single-${index}`"
          >
            <div class="port-item port-item-one">
              <component
                :is="calcPanel(item.type)"
                @port-click="() => emit('port-click', item)"
                @change="(num) => emit('change', num, item)"
                :type="item.type"
                :isEnabledTu="isEnabledTu && item.isEnabledTu"
                v-model:tu="item.tu"
                :port="item.portNum"
                :popover="popover"
                :isEnabled="isEnabled && item.isEnabled"
                :status="item.status"
                :borderStatus="item.borderStatus"
                v-model="item.selected"
                :hex="item.hex"
                :mode="item.mode"
                :detach="item.detach"
                :lag="item.lag"
                :priority="item.priority"
                :vendor="item.detect"
                :config="item.config"
                :isFanout="false"
                :value="item.selected"
              >
                {{ item.value }}
              </component>
            </div>
          </div>
        </div>
      </template>
    </div>
</template>

<script setup>
import { computed, defineEmits } from 'vue'
import sakuraPortLan from './sakura-port-lan'
import sakuraPortLanLarge from './sakura-port-lan-large'

// Props
const props = defineProps({
  popover: {
    type: Boolean,
    default: false
  },
  value: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: true
  },
  isEnabled: {
    type: Boolean,
    default: true
  },
  isEnabledTu: {
    type: Boolean,
    default: false
  },
  list: {
    type: Array,
    default: () => []
  }
})

// Emits
const emit = defineEmits(['change', 'port-click', 'port-click-fanout'])
const evenList = computed(() => props.list.filter((_, i) => i % 2 === 0));
const oddList = computed(() => props.list.filter((_, i) => i % 2 !== 0));

// Utility Methods
const isLarge = (type) => ['plus', 'hdmi'].includes(type)

const calcPanel = (type) => isLarge(type) ? sakuraPortLanLarge : sakuraPortLan
</script>


<style lang="scss" scoped>
@use "@/css/base.scss" as *;

.net-work-row {
    height: 50px;
    border-left: 1px solid $network-border-color;
}

.net-work-port {
    flex: 1;
    height: inherit;
    min-width: 50px;

    .port-item {
        height: 100%;
        line-height: 50px;
        text-align: center;
        position: relative;
    }

    .port-item-one {
        border-top: 1px solid $network-border-color;
        border-right: 1px solid $network-border-color;
        border-bottom: 1px solid $network-border-color;
    }

    .port-item-two {
        border-right: 1px solid $network-border-color;
    }

    .port-item port-item-one:last-child,
    .port-item port-item-two:last-child {
        border-right: none;
    }
}
</style>
